import { Component } from '@angular/core';
import { UiService } from '../../services/ui.service';

/**
 This component will display a preloader image on the screen. It can be a progress bar or a spinner.

 Usage:
   In order to be used you should include a <lms-preloader> tag in you page, import UiService (and PreloaderType) from ui.service
   and use one of its methods: displayPreloader and hidePreloader

 Usage examples:

    uiService.displayPreloader(PreloaderType.Spinner);
            Displays a spinner image on the screen

    uiService.displayPreloader(PreloaderType.ProgressBarIndeterminate);
            Displays a progress bar that is flashing continuosly

    uiService.displayPreloader(PreloaderType.ProgressBarDeterminate, { width: "40"}) ;
            Displays a progress bar statically filled in a 40%

    uiService.hidePreloader() ;
            Removes the preloader image from the screen
*/
@Component({
  selector: 'app-preloader',
  templateUrl: './preloader.component.html',
  styleUrls: ['preloader.component.scss']
})
export class PreloaderComponent {
  constructor(public uiService: UiService) {}
}
